import RasterDatastoreHandler from './RasterDatastoreHandler'

export default class TifDatastoreHandler extends RasterDatastoreHandler {
  constructor() {
    super('tif')
  }
}
